
import {createComponent} from './utils';

export default createComponent([{"path":"M65.23884 456.152041 958.760137 456.152041l0 111.695918L65.23884 567.847959 65.23884 456.152041z"}]);

